module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-461.4aee606.woff2";